// services/departmentService.js
import { departmentsAPI } from './api';

export const departmentService = {
  async getDepartments() {
    try {
      const response = await departmentsAPI.getAll();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching departments:', error);
      throw new Error(error.response?.data?.message || 'Failed to load departments');
    }
  },

  async getDepartment(id) {
    try {
      const response = await departmentsAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching department:', error);
      throw new Error(error.response?.data?.message || 'Failed to load department');
    }
  },

  async createDepartment(department) {
    try {
      console.log('📤 Creating department:', department);
      const response = await departmentsAPI.create(department);
      console.log('✅ Department created:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating department:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to create department';
      throw new Error(errorMessage);
    }
  },

  async updateDepartment(id, department) {
    try {
      console.log(`📤 Updating department ${id}:`, department);
      const response = await departmentsAPI.update(id, department);
      console.log('✅ Department updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating department:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to update department';
      throw new Error(errorMessage);
    }
  },

  async deleteDepartment(id) {
    try {
      await departmentsAPI.delete(id);
    } catch (error) {
      console.error('❌ Error deleting department:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete department');
    }
  }
};